/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

export const TableRows = (data) => {
  return data?.map((record, idx) => {
    return {
      id: idx + 1,
      visit_date: record?.visit_date,
      visit_time: record.visit_time,
      created_date: record?.created_date,
      created_time: record?.created_time,
      created_lead_time: record.created_lead_time,
      cancelled_date: record.canceled_date,
      no_show_date: record.no_show_date,
      seated_date: record.seated_date,
      finished_date: record.finished_date,
      last_updated: record.last_updated,
      actual_duration: record.actual_duration,
      guest_name: `${record?.guest?.first_name}`,
      phone_number: record?.guest?.phone_number,
      email: record?.guest?.email,
      marketing_opt_in: record?.guest?.marketing_opt_in,
      company: record.guest.company,
      birthday: record?.guest?.birthday,
      anniversary: record?.guest?.anniversary,
      size: record.size,
      status: record.status,
      table: record.table,
      table_type: record.table_type,
      dining_area_assigned: record.dining_area_assigned,
      dining_area_booked: record.dining_area_booked,
      source: record.source,
      online_channel: record.online_channel,
      partner: record.partner,
      open_table_boost_type: record?.restaurant?.open_table_boost_type,
      campaign_details: record.restaurant.campaign_details,
      restref_source: record.restaurant.rest_ref_source,
      restref_campaign_name: record.restaurant.rest_ref_campaign_name,
      turn_time_setting: record.restaurant.turn_time_setting,
      online_waitlist: record.restaurant.online_waitlist,
      quoted_wait_time: record.quoted_wait_time,
      total_wait_time: record.total_wait_time,
      created_by: record.created_date,
      server: record.server,
      referrer_name: record.referrer_name,
      referrer_business: record.referrer_business,
      restref_id: record.rest_ref_id,
      experience_title: record.experience?.experience_title,
      experience_type: record.experience?.experience_type,
      experience_subtotal: record.experience?.experience_subtotal,
      addons_subtotal: record.experience?.addons_subtotal,
      experience_total_revenue: record.experience?.experience_total_revenue,
      service_charges: record.experience?.service_charges,
      service_gratuity: record.experience?.experience_gratuity,
      experience_tax: record.experience?.experience_tax,
      experience_total_income: record.experience?.experience_total_income,
      pos_revenue: record.payment?.pos_revenue,
      pos_gratuity: record.payment?.pos_revenue,
      pos_check_ids: record.payment?.pos_check_ids,
      prepayment_method: record.payment?.prepayment_method,
      prepayment_status: record.payment?.prepayment_status,
      prepayment_required_total: record.payment?.prepayment_required_total,
      prepayment_paid_total: record.payment?.prepayment_paid_total,
      prepayment_refunded_total: record.payment?.prepayment_refunded_total,
      payment_processor_payout_date:
        record.payment?.payment_processor_payout_date,
      payment_processor_transaction_fee:
        record.payment?.payment_processor_transaction_fee,
      opentable_service_fee: record.restaurant.open_table_service_fee,
      opentable_boost_fee: record.restaurant.open_table_boost_fee,
      total_revenue: record.restaurant.total_revenue,
      total_gratuity: record.restaurant.total_gratuity,
      guest_requests: record?.notes[0]?.guest_requests,
      visit_notes: record?.notes[0]?.visit_notes,
      reservation_tags: record?.notes[0]?.reservation_tags,
      guest_tags: record?.notes[0]?.guest_tags,
      general_notes: record?.notes[0]?.general_notes,
      special_relationships: record?.notes[0]?.special_relationship,
      seating_preferences: record?.notes[0]?.seating_preferences,
      food_drink_preferences: record?.notes[0]?.food_drink_preferences,
      first_visit_date: record?.guest?.first_visit_date,
      recent_visit_date: record.guest?.recent_visit_date,
      upcoming_visits: record?.guest?.upcoming_visits,
      completed_visits: record?.guest?.completed_visits,
      cancelled_count: record?.guest?.canceled_count,
      no_show_count: record?.guest?.no_show_count,
      lifetime_spend: record?.guest?.lifetime_spend,
      lifetime_per_cover_spend: record?.guest?.lifetime_per_cover_spend,
    };
  });
};
